import { Component, OnInit } from '@angular/core';
import { TotemService } from '../totem.service';
import { GoogleAnalyticsService } from '../google-analytics.service';
import * as moment from 'moment';
import { Tienda } from '../tiendas/tienda';
import { element } from 'protractor';
import { environment } from 'src/environments/environment';
import { Categoria } from '../tiendas/categoria';
import { Subcategoria } from '../tiendas/subcategoria';
@Component({
  selector: 'app-ofertas',
  templateUrl: './ofertas.component.html',
  styleUrls: ['./ofertas.component.css']
})
export class OfertasComponent implements OnInit {
  listaoferta = [];
  descuento;
  tiendasIniciales = [];
  tiendas = [];
  tiendasfil = [];
  tiendasPorOferta = [];
  subcategoriReales = [];
  categoriactual;
  otherTiendasresult = [];
  subcategorias: Array<Subcategoria> = [];
  imagenTienda = 'assets/placeholders/logo-tiendas.jpg';
  constructor(  private totemService: TotemService, private googleAnalyticsService: GoogleAnalyticsService) { }

  async ngOnInit() {
    //  lista de tiendas
    const tiendas = await this.totemService.getTiendas().toPromise();
    this.tiendasIniciales = tiendas.map((tienda: any) => new Tienda(tienda));
    const obtenerTiendas = new Promise((resolve , reject) => {
      const listatiendas = [];
      this.tiendasIniciales.forEach(tienda => {
        if (tienda.estado.toString() === 'Habilitado') {
          if (environment.tiendaimagen) {
            if (!tienda.logo || tienda.logo === '') {
              tienda.logo = this.imagenTienda;
            }
            listatiendas.push(tienda);
          } else {
            if (tienda.logo || tienda.logo !== '') {
              listatiendas.push(tienda);
            }
          }
        }
      });
      this.tiendas = this.tiendasIniciales.slice();
      resolve('ok');
    });
    //  lista de ofertas
    const obtenerOfertas = new Promise((resolve, reject) => {
      const eventoslist = this.totemService.geteventos().subscribe(eventos => {
        for (const evento of eventos) {
          if (evento.tipo_evento === 'Oferta' && evento.publicado === 1) {
            if (moment().isBetween(evento.dia_inicio, evento.dia_termino)) {
              if (!evento.descuento || evento.descuento === null || evento.descuento === '0') {
                evento.haydescuento = false;
              } else {
                evento.haydescuento = true;
              }
              this.listaoferta.push(evento);
            }
          }
        }
        console.log('lista de odertas', this.listaoferta);
        resolve('ok');
      });
    });
    const items = await this.totemService.getCategorias().toPromise();
    const categorias = items.map(item => new Categoria(item));


    // filtrar tiendas por
    obtenerTiendas.then((response) => {
      obtenerOfertas.then((response2) => {
        this.tiendas.forEach(tienda => {
            this.listaoferta.forEach(oferta => {
              if ( oferta.punto_interes === tienda.puntoInteres) {
                const dato = tienda;
                dato.haydescuento = oferta.haydescuento;
                dato.descuento = oferta.descuento;
                dato.precio = oferta.precio;
                dato.titulo = oferta.titulo;
                this.tiendasPorOferta.push(dato);
              }
            });
         });
        this.otherTiendasresult =  this.tiendasPorOferta.slice();
        console.log('la lista de tiendas pro oferta ', this.tiendasPorOferta);
        for (const categoria of categorias) {
          const subcategorias = categoria.subcategorias;
          for (const subcategoria of subcategorias) {
            subcategoria.tiendas = this.tiendasPorOferta.filter((tienda: Tienda) => {
              return tienda.subcategorias.find(idSubcategoria => {
                return idSubcategoria === subcategoria.id;
              });
            });
            this.subcategorias.push(subcategoria);
          }
        }
        for (const subcat of this.subcategorias) {
          if (subcat.tiendas.length !== 0) {
            const nombre = subcat.nombre.toLowerCase();
            subcat.nombre = nombre.charAt(0).toUpperCase() + nombre.slice(1);
            this.subcategoriReales.push(subcat);
          }
        }
        // console.log('subca ',this.subcategoriReales);
      }).catch((error) => {
        console.log(error);
      });
    }).catch((error) => {
      console.log(error);
    });
  }

  public filtrarCategorias(subcategoria) {
    console.log('subcate', subcategoria);
    if (this.categoriactual !== subcategoria.nombre) {
          this.categoriactual = subcategoria.nombre;
          const listatiendasfiltradas = [];
          for (const suca of subcategoria.tiendas) {
                listatiendasfiltradas.push(suca);
          }
          this.otherTiendasresult = listatiendasfiltradas;
          this.enviarEventoFiltro(subcategoria.nombre);

      } else {
        this.categoriactual = '';
        this.otherTiendasresult = this.tiendasPorOferta.slice();
        this.enviarEventoFiltro('sin-categoria');
      }
    }
    public enviarEventoFiltro(categoria) {
      this.googleAnalyticsService.eventEmitter(
        'ofertas',
        'filter',
        categoria
      );
    }
  // logica de reinicio
 scrollevent = (event: any): void => {
  console.log('scroll');
  this.cancelartimer();
}
public cancelartimer() {
 this.totemService.emitirReinicioTotem();
}
}
